// Libs
import { Components, outlinedInputClasses, Theme } from '@mui/material';
// Others

export const muiOverride: Components<Theme> = {
  // Input
  MuiInputBase: {
    styleOverrides: {
      root: {
        border: 'none',
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      input: { padding: 0 },
      root: ({ theme }) => ({
        padding: '15px 18px',
        fontSize: `${theme.typography.fontSize}px`,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '24px',
        '&:hover': {
          borderColor: `${theme.palette.divider}`,
        },
        [`&.${outlinedInputClasses.focused}`]: {
          borderColor: `${theme.palette.primary.main}`,
        },
        backgroundColor: `${theme.palette.background.paper}`,
        variants: [
          {
            props: { size: 'small' },
          },
          {
            props: { size: 'medium' },
          },
        ],
      }),
      notchedOutline: { border: 'none' },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: ({ theme }) => ({
        color: `${theme.palette.text.primary}`,
        fontSize: `${theme.typography.fontSize}px`,
        marginBottom: '13px',
      }),
      asterisk: ({ theme }) => ({
        marginLeft: '4px',
        color: `${theme.palette.error.main}`,
      }),
    },
  },

  // Button
  MuiButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none',
        },
        variants: [
          {
            props: { variant: 'outlined' },
            style: {
              border: `1px solid transparent`,
              borderRadius: '6px',
              '&:hover': {
                border: `1px solid ${theme.palette.primary.main}`,
              },
            },
          },
          {
            props: { variant: 'contained' },
            style: {
              borderRadius: '6px',
            },
          },
        ],
      }),
    },
  },

  MuiDivider: {
    styleOverrides: {
      wrapper: {
        margin: '0 36px',
      },
    },
  },

  MuiTabs: {
    styleOverrides: {
      list: ({ theme }) => ({
        gap: '40px',
      }),
    },
  },

  // Dialog
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: '12px',
        overflow: 'hidden',
      },
    },
  },

  MuiDialogTitle: {
    styleOverrides: {
      root: {
        padding: 24,
        paddingBottom: 0,
        backgroundColor: '#ffffff',
        fontSize: '20px',
        fontWeight: '600',
        color: '#000000',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
      },
    },
  },

  MuiDialogContent: {
    styleOverrides: {
      root: {
        backgroundColor: '#ffffff',
        border: 'none',
        padding: 24,
      },
    },
  },

  MuiDialogActions: {
    styleOverrides: {
      root: {
        gap: 4,
        backgroundColor: '#ffffff',
        padding: 24,
        paddingTop: 0,
        position: 'sticky',
        bottom: 0,
        zIndex: 1000,
      },
    },
  },
};
